import * as XLSX from 'xlsx';

export const SHOPLINE_TEMPLATE_HEADERS_EN = [
  'Product Handle*',
  'Product Name(Chinese)*',
  'Product Name(English)*',
  'Product Summary(Chinese)',
  'Product Summary(English)',
  'Product Description(Chinese)',
  'Product Description(English)',
  'SEO Title(Chinese)',
  'SEO Title(English)',
  'SEO Description(Chinese)',
  'SEO Description(English)',
  'SEO Keywords',
  'Preorder Item (Preorder Feature)',
  'Preorder Note(Chinese)',
  'Preorder Note(English)',
  'Unlimited Preorder Supply',
  'Preorder Limit',
  'Online Store Status',
  'Retail Store Status',
  'Images*',
  'Additional Images',
  'Online Store Categories(Chinese)',
  'Online Store Categories(English)',
  'POS Categories(Chinese)',
  'POS Categories(English)',
  'Price',
  'Sales Price',
  'Product Retail Store Price',
  'Store-Specific Price',
  'Cost',
  'Domestic Tax Type',
  'Oversea Tax Type',
  'SKU',
  'Member Price',
  'Quantity',
  'Weight(KG)',
  'Supplier',
  'Product Tag',
  'Hidden Product',
  'Exclude Payment Options',
  'Exclude Delivery Options',
  'Specification Name A(Chinese)',
  'Specification Name A(English)',
  'Specification Name B(Chinese)',
  'Specification Name B(English)',
  'Variation Image',
  'Variation name A(Chinese)',
  'Variation name A(English)',
  'Variation name B(Chinese)',
  'Variation name B(English)',
  'Variation quantity',
  'Variation price',
  'Variant Sale Price',
  'Variant Retail Store Price',
  'Variant Store-Specific Price',
  'Variant Member Price',
  'Variant Cost',
  'Variation SKU',
  'Variant Weight(KG)',
  'Barcode'
];

export const SHOPLINE_TEMPLATE_HEADERS_ZH = [
  '商品編號*',
  '商品名稱(中文)*',
  '商品名稱(英文)*',
  '商品摘要(繁體中文)',
  '商品摘要(英文)',
  '商品描述(中文)',
  '商品描述(英文)',
  'SEO標題(中文)',
  'SEO標題(英文)',
  'SEO簡介(中文)',
  'SEO簡介(英文)',
  'SEO關鍵字',
  '預購商品 (預購功能)',
  '預購提示(中文)',
  '預購提示(英文)',
  '預購商品可無限供貨',
  '預購上限',
  '網店上架狀態',
  '實體店上架狀態',
  '相片 (每件產品最多12張主要圖片， Max. 12 images for each product)*',
  '更多相片 (每件產品最多20張主要圖片， Max.20 images for each product)',
  '網店分類(繁體中文)',
  '網店分類(英文)',
  'POS分類(繁體中文)',
  'POS分類(英文)',
  '原價格',
  '特價',
  '實體店價格',
  '分店價',
  '成本價',
  '國內稅項',
  '海外稅項',
  '商品貨號',
  '商品會員價',
  '數量',
  '重量(KG)',
  '供應商',
  '商品管理標籤',
  '隱藏商品',
  '排除的付款方式',
  '排除的送貨方式',
  '規格名稱1(中文)',
  '規格名稱1(英文)',
  '規格名稱2(中文)',
  '規格名稱2(英文)',
  '款式圖片 (每個款式最多 1 張款式圖片， Max.1 image for each variant)',
  '選項名稱A(中文)',
  '選項名稱A(英文)',
  '選項名稱B(中文)',
  '選項名稱B(英文)',
  '選項數量',
  '選項價格',
  '款式特價',
  '款式實體店價格',
  '款式分店價',
  '款式會員價',
  '款式成本',
  '選項商品貨號',
  '款式重量(KG)',
  '商品條碼編號'
];

const SHOPIFY_ALIASES = {
  body: ['Body (HTML)', 'Description'],
  comparePrice: ['Variant Compare At Price', 'Compare-at price'],
  cost: ['Cost per item', 'Variant Cost'],
  grams: ['Variant Grams', 'Weight value (grams)'],
  handle: ['Handle'],
  image: ['Image Src', 'Product image URL', 'Product Image URL'],
  inventoryQty: ['Variant Inventory Qty', 'Inventory quantity'],
  option1Name: ['Option1 Name', 'Option 1 name'],
  option1Value: ['Option1 Value', 'Option 1 value'],
  option2Name: ['Option2 Name', 'Option 2 name'],
  option2Value: ['Option2 Value', 'Option 2 value'],
  option3Name: ['Option3 Name', 'Option 3 name'],
  option3Value: ['Option3 Value', 'Option 3 value'],
  price: ['Variant Price', 'Price'],
  productCategory: ['Type', 'Product Category', 'Product category'],
  published: ['Published', 'Published on online store'],
  seoDescription: ['SEO Description', 'SEO description'],
  seoTitle: ['SEO Title', 'SEO title'],
  sku: ['Variant SKU', 'SKU'],
  status: ['Status'],
  tags: ['Tags'],
  title: ['Title'],
  vendor: ['Vendor'],
  variantBarcode: ['Variant Barcode', 'Barcode'],
  variantImage: ['Variant Image', 'Variant image URL', 'Variant Image URL'],
  variantWeight: ['Variant Weight', 'Weight'],
  variantWeightUnit: ['Variant Weight Unit', 'Weight unit for display']
};

function getCell(row, keys) {
  if (!row || !Array.isArray(keys)) {return '';}

  for (const key of keys) {
    const value = row[key];
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      return String(value).trim();
    }
  }

  return '';
}

function toNumber(value) {
  if (value === null || value === undefined || value === '') {return null;}
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function formatNumeric(value) {
  const num = toNumber(value);
  return num === null ? '' : String(num);
}

function stripHtml(html) {
  if (!html) {return '';}
  return String(html)
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
}

function truncate(value, max = 300) {
  if (!value) {return '';}
  return value.length > max ? value.slice(0, max) : value;
}

function isTruthyPublished(value) {
  const normalized = String(value || '').toLowerCase().trim();
  return normalized === 'true' || normalized === 'y' || normalized === '1';
}

function isHiddenStatus(value) {
  const normalized = String(value || '').toLowerCase().trim();
  return normalized === 'draft' || normalized === 'archived';
}

function extractUrls(value) {
  if (!value) {return [];}
  const str = String(value).trim();
  if (!str) {return [];}

  const urlMatches = str.match(/https?:\/\/[^\s,]+/g);
  if (urlMatches?.length) {
    return [...new Set(urlMatches)];
  }

  return [...new Set(
    str
      .split(/[,\n]+/)
      .map(v => v.trim())
      .filter(Boolean)
  )];
}

function collectProductImages(product, variants) {
  const all = [];
  const add = (value) => {
    for (const url of extractUrls(value)) {
      if (!all.includes(url)) {
        all.push(url);
      }
    }
  };

  add(getCell(product, SHOPIFY_ALIASES.image));

  for (const variant of variants) {
    add(getCell(variant, SHOPIFY_ALIASES.image));
    add(getCell(variant, SHOPIFY_ALIASES.variantImage));
  }

  return all;
}

function isDefaultSingleVariant(variant) {
  const option1Name = getCell(variant, SHOPIFY_ALIASES.option1Name).toLowerCase();
  const option1Value = getCell(variant, SHOPIFY_ALIASES.option1Value).toLowerCase();
  const option2Value = getCell(variant, SHOPIFY_ALIASES.option2Value);
  const option3Value = getCell(variant, SHOPIFY_ALIASES.option3Value);

  if (option2Value || option3Value) {
    return false;
  }

  return option1Name === 'title' && (option1Value === 'default title' || option1Value === 'default');
}

function parseWeightKg(variant) {
  const rawWeight = toNumber(getCell(variant, SHOPIFY_ALIASES.variantWeight));
  const rawUnit = getCell(variant, SHOPIFY_ALIASES.variantWeightUnit).toLowerCase();
  const rawGrams = toNumber(getCell(variant, SHOPIFY_ALIASES.grams));

  if (rawWeight !== null) {
    if (rawUnit === 'g' || rawUnit === 'gram' || rawUnit === 'grams') {
      return rawWeight / 1000;
    }
    if (rawUnit === 'lb' || rawUnit === 'lbs' || rawUnit === 'pound' || rawUnit === 'pounds') {
      return rawWeight * 0.453592;
    }
    if (rawUnit === 'oz' || rawUnit === 'ounce' || rawUnit === 'ounces') {
      return rawWeight * 0.0283495;
    }
    return rawWeight;
  }

  if (rawGrams !== null) {
    return rawGrams / 1000;
  }

  return null;
}

function mapPriceAndSales(priceValue, compareAtValue) {
  const price = toNumber(priceValue);
  const compareAt = toNumber(compareAtValue);

  if (price === null && compareAt === null) {
    return { price: '', salesPrice: '' };
  }

  if (price !== null && compareAt !== null && compareAt > price) {
    return { price: String(compareAt), salesPrice: String(price) };
  }

  return { price: price !== null ? String(price) : '', salesPrice: '' };
}

function createVariantRow(product, variant, context) {
  const row = {};
  const priceData = mapPriceAndSales(
    getCell(variant, SHOPIFY_ALIASES.price),
    getCell(variant, SHOPIFY_ALIASES.comparePrice)
  );

  const option1Name = getCell(product, SHOPIFY_ALIASES.option1Name);
  const option2Name = getCell(product, SHOPIFY_ALIASES.option2Name);
  const option3Name = getCell(product, SHOPIFY_ALIASES.option3Name);

  row['Product Handle*'] = context.handle;
  row['Product Name(Chinese)*'] = context.title;
  row['Product Name(English)*'] = context.title;
  row['Product Summary(English)'] = context.summary;
  row['Product Description(English)'] = context.descriptionHtml;
  row['SEO Title(English)'] = context.seoTitle;
  row['SEO Description(English)'] = context.seoDescription;
  row['SEO Keywords'] = context.tags;
  row['Preorder Item (Preorder Feature)'] = 'N';
  row['Unlimited Preorder Supply'] = 'N';
  row['Online Store Status'] = context.onlineStatus;
  row['Retail Store Status'] = context.onlineStatus;
  row['Images*'] = context.mainImage;
  row['Additional Images'] = context.additionalImages;
  row['Online Store Categories(English)'] = context.category;
  row['Price'] = context.basePrice.price;
  row['Sales Price'] = context.basePrice.salesPrice;
  row['Cost'] = context.baseCost;
  row['SKU'] = context.firstSku;
  row['Quantity'] = context.firstInventoryQty;
  row['Weight(KG)'] = context.firstWeightKg;
  row['Supplier'] = context.vendor;
  row['Product Tag'] = context.tags;
  row['Hidden Product'] = context.hiddenProduct;

  if (!isDefaultSingleVariant(variant)) {
    row['Specification Name A(English)'] = option1Name === 'Title' ? '' : option1Name;
    row['Specification Name B(English)'] = option2Name || (option3Name ? 'Option3' : '');
    row['Variation name A(English)'] = getCell(variant, SHOPIFY_ALIASES.option1Value);
    row['Variation name B(English)'] = getCell(variant, SHOPIFY_ALIASES.option2Value) || getCell(variant, SHOPIFY_ALIASES.option3Value);
  }

  row['Variation Image'] = getCell(variant, SHOPIFY_ALIASES.variantImage);
  row['Variation quantity'] = getCell(variant, SHOPIFY_ALIASES.inventoryQty);
  row['Variation price'] = priceData.price;
  row['Variant Sale Price'] = priceData.salesPrice;
  row['Variant Cost'] = formatNumeric(getCell(variant, SHOPIFY_ALIASES.cost));
  row['Variation SKU'] = getCell(variant, SHOPIFY_ALIASES.sku);
  row['Variant Weight(KG)'] = formatNumeric(parseWeightKg(variant));
  row['Barcode'] = getCell(variant, SHOPIFY_ALIASES.variantBarcode);

  return row;
}

function createFollowupVariantRow(handle, variant, includeSecondOption) {
  const row = {};
  const priceData = mapPriceAndSales(
    getCell(variant, SHOPIFY_ALIASES.price),
    getCell(variant, SHOPIFY_ALIASES.comparePrice)
  );

  row['Product Handle*'] = handle;
  row['Variation Image'] = getCell(variant, SHOPIFY_ALIASES.variantImage);
  row['Variation name A(English)'] = getCell(variant, SHOPIFY_ALIASES.option1Value);
  if (includeSecondOption) {
    row['Variation name B(English)'] = getCell(variant, SHOPIFY_ALIASES.option2Value) || getCell(variant, SHOPIFY_ALIASES.option3Value);
  }
  row['Variation quantity'] = getCell(variant, SHOPIFY_ALIASES.inventoryQty);
  row['Variation price'] = priceData.price;
  row['Variant Sale Price'] = priceData.salesPrice;
  row['Variant Cost'] = formatNumeric(getCell(variant, SHOPIFY_ALIASES.cost));
  row['Variation SKU'] = getCell(variant, SHOPIFY_ALIASES.sku);
  row['Variant Weight(KG)'] = formatNumeric(parseWeightKg(variant));
  row['Barcode'] = getCell(variant, SHOPIFY_ALIASES.variantBarcode);

  return row;
}

function productToRows(product, index) {
  const handle = getCell(product, SHOPIFY_ALIASES.handle) || `product-${index + 1}`;
  const title = getCell(product, SHOPIFY_ALIASES.title) || `Product ${index + 1}`;
  const descriptionHtml = getCell(product, SHOPIFY_ALIASES.body);
  const summary = truncate(stripHtml(descriptionHtml), 300);
  const seoTitle = getCell(product, SHOPIFY_ALIASES.seoTitle) || title;
  const seoDescription = getCell(product, SHOPIFY_ALIASES.seoDescription) || summary;
  const tags = getCell(product, SHOPIFY_ALIASES.tags);
  const vendor = getCell(product, SHOPIFY_ALIASES.vendor);
  const category = getCell(product, SHOPIFY_ALIASES.productCategory);
  const onlineStatus = isTruthyPublished(getCell(product, SHOPIFY_ALIASES.published)) ? 'Y' : 'N';
  const hiddenProduct = isHiddenStatus(getCell(product, SHOPIFY_ALIASES.status)) ? 'Y' : 'N';

  const rawVariants = [product, ...(Array.isArray(product.variants) ? product.variants : [])];
  const variants = rawVariants.filter((variant) => {
    return Boolean(
      getCell(variant, SHOPIFY_ALIASES.sku) ||
      getCell(variant, SHOPIFY_ALIASES.price) ||
      getCell(variant, SHOPIFY_ALIASES.inventoryQty) ||
      getCell(variant, SHOPIFY_ALIASES.option1Value) ||
      getCell(variant, SHOPIFY_ALIASES.option2Value) ||
      getCell(variant, SHOPIFY_ALIASES.option3Value) ||
      getCell(variant, SHOPIFY_ALIASES.title)
    );
  });

  const normalizedVariants = variants.length ? variants : [product];
  const images = collectProductImages(product, normalizedVariants);
  const firstVariant = normalizedVariants[0];
  const basePrice = mapPriceAndSales(
    getCell(firstVariant, SHOPIFY_ALIASES.price),
    getCell(firstVariant, SHOPIFY_ALIASES.comparePrice)
  );
  const firstWeightKg = parseWeightKg(firstVariant);
  const firstSku = getCell(firstVariant, SHOPIFY_ALIASES.sku);
  const firstInventoryQty = getCell(firstVariant, SHOPIFY_ALIASES.inventoryQty);
  const baseCost = formatNumeric(getCell(firstVariant, SHOPIFY_ALIASES.cost));

  const context = {
    additionalImages: images.slice(1).join(' '),
    baseCost,
    basePrice,
    category,
    descriptionHtml,
    firstInventoryQty,
    firstSku,
    firstWeightKg: firstWeightKg === null ? '' : String(firstWeightKg),
    handle,
    hiddenProduct,
    mainImage: images[0] || '',
    onlineStatus,
    seoDescription,
    seoTitle,
    summary,
    tags,
    title,
    vendor
  };

  const rows = [];
  const hasMultipleVariants = normalizedVariants.length > 1 || !isDefaultSingleVariant(normalizedVariants[0]);
  const includeSecondOption = Boolean(getCell(product, SHOPIFY_ALIASES.option2Name) || getCell(product, SHOPIFY_ALIASES.option3Name));

  normalizedVariants.forEach((variant, variantIndex) => {
    if (variantIndex === 0) {
      rows.push(createVariantRow(product, variant, context));
      return;
    }

    if (hasMultipleVariants) {
      rows.push(createFollowupVariantRow(handle, variant, includeSecondOption));
    }
  });

  return rows;
}

function rowsToAoa(rows) {
  return rows.map((row) => SHOPLINE_TEMPLATE_HEADERS_EN.map((header) => row[header] || ''));
}

export function convertShopifyProductsToShoplineRows(shopifyProducts) {
  if (!Array.isArray(shopifyProducts)) {
    throw new Error('Shopify product data must be an array');
  }

  const rows = [];
  shopifyProducts.forEach((product, index) => {
    rows.push(...productToRows(product, index));
  });

  return rows;
}

export function generateShoplineXlsxFromShopify(shopifyProducts) {
  const rows = convertShopifyProductsToShoplineRows(shopifyProducts);

  const workbook = XLSX.utils.book_new();
  const worksheetData = [
    SHOPLINE_TEMPLATE_HEADERS_EN,
    SHOPLINE_TEMPLATE_HEADERS_ZH,
    ...rowsToAoa(rows)
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Default');

  return {
    arrayBuffer: XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }),
    rowCount: rows.length,
    workbook
  };
}
